export const HIDE_MESSAGE = 'message/HIDE';

export const hideMessage = () => ({ type: HIDE_MESSAGE });
